<template >
  <div>
    <svg class="display-none">
      <defs>
        <pattern
          v-for="item in colors.camos"
          :key="generateId(item)"
          :id="item.name"
          patternContentUnits="objectBoundingBox"
          height="100%"
          width="100%"
        >
          <image
            height="1"
            width="1"
            preserveAspectRatio="none"
            v-bind:xlink:href="getSvgUrl(item.name, 'camos')"
          />
        </pattern>
        <pattern
          v-for="item in colors.prints"
          :key="generateId(item)"
          :id="item.name"
          patternContentUnits="objectBoundingBox"
          height="100%"
          width="100%"
        >
          <image
            height="1"
            width="1"
            preserveAspectRatio="none"
            v-bind:xlink:href="getSvgUrl(item.name, 'prints')"
          />
        </pattern>
      </defs>
    </svg>
    <h1 class="text-xs-center">Order Confirmation</h1>
    <p class="text-xs-center body-2">
      You have successfully placed an order to Caos Suits. We will
      make your suit as soon as possible. If we have any questions, we will
      contact you at the email you provided.
    </p>
    <v-card>
      <v-card-text>
        <v-layout row wrap justify-center>
          <v-flex
            xs10
            sm6
            md4
            lg3
            v-for="item in order.contact"
            :key="item.id"
            class="px-2"
          >
            <v-text-field
              readonly
              box
              :title="item.title"
              :label="item.label + ':'"
              class="measurements-input"
              type="text"
              :id="item.label"
              :name="item.label"
              v-model="item.value"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card
      flat
      class="my-4 pa-3"
      color="grey lighten-2"
      v-for="suit in order.orders"
      :key="suit.suits.front"
    >
      <Preview :order="suit" :admin="false" />
    </v-card>
  </div>
</template>

<script>
import Preview from "@/components/OverView";
import axios from "axios";
import { db } from "../firebase";
import { mixin } from "@/mixins/index.js";
export default {
  data() {
    return {
      order: [],
    };
  },
  components: {
    Preview,
  },
  mixins: [mixin],
  computed: {
    colors() {
      return this.$store.getters.colors;
    },
  },
  methods: {
    getImgUrl(name) {
      return require("../assets/camos/" + name + ".jpg");
    },
  },
  async created() {
    let url = this.$route.params.id;
    let data = await db.collection("orders").doc(url).get();
    this.order = data.data().order || data.data();
    console.log(data.data());
    let href = `https://caos.store/`;
    let email = this.order.contact.email.value;
    this.$store.dispatch({ type: "clear" });
    async function sendEms() {
      let em1 = axios.post(process.env.VUE_APP_SEND_URL, {
        to: [
          "info@caos.store",
          "caossuits@gmail.com",
          "heathweeks2626@outlook.com",
          "mbute41@gmail.com",
        ],
        //to:["mbute41@gmail.com"],
        subject: "Caos Suits",
        type: "order",
        message: `There is new order on caossuits.com.au, you can check it here:<br><a href="${href}orders/${url}">${href}orders/${url}</a>`,
      });
      let em2 = axios.post(process.env.VUE_APP_SEND_URL, {
        to: email,
        subject: "Caos Suits",
        email: "CEO of Caos Suits",
        type: "confirmation",
        name: "Heath Thomas Weeks",
        message: `You successfully added an order to caossuits.com.au, you can check your order information here:<br><a href="${href}confirmation/${url}">${href}confirmation/${url}</a>`,
      });
      let result = (await em1) + em2;
      return result;
    }
    if (!this.order.sent) {
      sendEms();
      db.collection("orders").doc(url).update({ "order.sent": true });
    }
  },
};
</script>
